import React from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { MenuPanelItemStyled } from "./styled";
import { Icons } from "components";

const MenuPanelItem = ({ theme_standard, label }) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });
  return (
    <MenuPanelItemStyled className={customClass}>
      <div className="menu_panel_name">{label}</div>
      <Icons.ArrowRightCircle2 color="#FFFFFF" />
    </MenuPanelItemStyled>
  );
};

MenuPanelItem.propTypes = {};

export default MenuPanelItem;
